import { render, staticRenderFns } from "./StatusHeaderCount.vue?vue&type=template&id=cf4423c2&scoped=true&"
import script from "./StatusHeaderCount.vue?vue&type=script&lang=js&"
export * from "./StatusHeaderCount.vue?vue&type=script&lang=js&"
import style0 from "./StatusHeaderCount.vue?vue&type=style&index=0&id=cf4423c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf4423c2",
  null
  
)

export default component.exports